import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';

const MONITOR_PATH = '/payment-queues';
const LEDGER_PATH = '/payment-queues/ledger';

export default function PaymentQueuesLayout() {
  const location = useLocation();
  const section = location.pathname.includes('/ledger') ? 'ledger' : 'monitor';

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        gap={0.5}
        sx={{ mb: 1 }}
      >
        <Box>
          <Typography variant="h5" lineHeight={1.2}>
            Filas de pagamento
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {section === 'ledger'
              ? 'Livro razão interno, lançamentos e reconciliação financeira.'
              : 'Monitor de reconciliação, worker e inscrições do período selecionado.'}
          </Typography>
        </Box>
      </Stack>

      <Tabs
        value={section}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 1.5,
          minHeight: 40,
          '& .MuiTab-root': { minHeight: 40, py: 0.75, textTransform: 'none', fontWeight: 600 },
        }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          label="Monitor"
          value="monitor"
          component={NavLink}
          to={MONITOR_PATH}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        />
        <Tab
          label="Ledger"
          value="ledger"
          component={NavLink}
          to={LEDGER_PATH}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        />
      </Tabs>

      <Outlet />
    </Box>
  );
}
